import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useTonStore } from '@/store/useTonStore.ts';

export const handleTonTransactionCreated = (ctxData: WebSocketMessage) => {
  if (ctxData.ton_transaction_created_event?.transaction) {
    const { updateBalance } = useTonStore.getState();

    updateBalance(ctxData.ton_transaction_created_event?.transaction);
  }
};
